import Swiper from "swiper";
export default class ProductGallery {
  constructor() {
    this.resizeEvent = this.resizeEvent.bind(this);
  }
  init() {
    this.initSliders();
  }
  setDOMElements() {
    this.$window = $(window);
    this.$productCovers = $(".js-products-images-cover");
    this.$productThumbs = $(".js-product-thumbs");
  }
  setHeight() {
    const height = this.$productCovers.find("img").height();
    this.$productCovers.height(height);
    this.$productThumbs.height(height);
  }
  resizeEvent() {
    if (this.$window.innerWidth() > 992) {
      this.galleryTop.changeDirection("vertical");
    } else {
      this.galleryTop.changeDirection("horizontal");
    }
    this.setHeight();
    this.galleryTop.update();
  }
  initSliders() {
    this.setDOMElements();
    this.setHeight();
    this.galleryThumbs = new Swiper(this.$productThumbs[0], {
      slidesPerView: "auto",
      direction: "vertical",
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: ".js-product-thumbs-next",
        prevEl: ".js-product-thumbs-prev"
      }
    });
    this.galleryTop = new Swiper(this.$productCovers[0], {
      direction: "vertical",
      thumbs: {
        slideThumbActiveClass: "swiper-thumb-active",
        swiper: this.galleryThumbs
      },
      pagination: {
        el: ".js-products-images-cover-pagination",
        type: "bullets",
        clickable: true
      },
      breakpoints: {
        992: {
          direction: "horizontal"
        }
      }
    });
    this.$window.off("resize", this.resizeEvent).on("resize", this.resizeEvent);
  }
}
